module.exports = __webpack_public_path__ + "img/parallax3-1920p.91cebf0a.jpg";